import { AuthPromptCard } from "../shared";

export type AuthLinkConfirmVariant = "password-reset" | "welcome";

interface AuthLinkConfirmViewProps {
  variant: AuthLinkConfirmVariant;
  isConfirming: boolean;
  /** Must never reject — the click handler below calls it as `void onConfirm()` and does not catch. */
  onConfirm: () => Promise<void>;
}

interface VariantCopy {
  heading: string;
  description: string;
  cta: string;
}

const COPY_BY_VARIANT: Record<AuthLinkConfirmVariant, VariantCopy> = {
  "password-reset": {
    heading: "Reset password",
    description: "Continue to choose a new password and get back into your workspace.",
    cta: "Continue to reset password",
  },
  welcome: {
    heading: "You're all set",
    description: "Your Paribus AI account is ready. Sign in to get started.",
    cta: "Continue to sign in",
  },
};

export const AuthLinkConfirmView = ({
  variant,
  isConfirming,
  onConfirm,
}: AuthLinkConfirmViewProps) => {
  const { heading, description, cta } = COPY_BY_VARIANT[variant];

  return (
    <AuthPromptCard
      heading={heading}
      description={description}
      cta={cta}
      isBusy={isConfirming}
      busyLabel="Confirming..."
      onAction={() => {
        void onConfirm();
      }}
    />
  );
};
